<template lang="pug">
  li.item-container.sheet-aggregate-tile(:style="`grid-template-columns: ${selectable ? '5em' : '0'} 14em 1fr ${actions.length ? '10em' : '0'};`")
    .attribute.select-aggregate
      label.checkbox-wrapper(v-if="selectable")
        input(type="checkbox" @change="select" :checked="selected")
        .checkbox-indicator
    .attribute.source-sit-id
      .source-sit {{ sheetAggregate.reference.source }}
      .id {{ sheetAggregate.reference.value.replace(/^ts_/, '') }}
    sheet-list(:sheets="sheetAggregate.sheets")
    .attribute-container.actions
      .attribute.action(v-for="action in actions" :key="action.event")
        button(@click="triggerAction(action)") {{ action.label }}
</template>

<script>
import SheetList from './sheet-list/SheetList.vue';

export default {
  name: 'SheetAggregateTile',
  components: {
    SheetList
  },
  props: {
    sheetAggregate: {
      type: Object,
      required: true,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    select(e) {
      this.$emit('select', {
        selected: e.target.checked,
        sheetAggregateId: this.sheetAggregate.reference.value,
      });
    },
    triggerAction(action) {
      this.$emit('action', {
        event: action.event,
        sheetAggregateId: this.sheetAggregate.reference.value,
      });
    },
  },
};
</script>

<style lang="scss">
  .sheet-aggregate-tile {
    color: #1A1A1A;
    font-size: 16px;
    .source-sit-id {
      display: flex;
      flex-direction: column;
      .id {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>